import { ApplicationInsights } from "@microsoft/applicationinsights-web";

export function initializeAzureAppInsights(instrumentationKey) {
  const appInsights = new ApplicationInsights({
    config: { instrumentationKey },
  });
  appInsights.loadAppInsights();
  appInsights.trackPageView();
}
